import { Component, Input, OnInit } from '@angular/core';
import { EAPP_FLOWS } from '@app/core/enums/app.enum';
import { ECUSTOMER_STATUS } from '../../../../core/enums/customer.enum';
import { APP_CONSTANTS as CONST } from '@app/app.constants';

@Component({
  selector: 'layout-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @Input() name?: string = 'Usuario';
  @Input() flow!: string;
  @Input() customerStatus: string;
  @Input() customerValidation: boolean;
  @Input() step: number;

  public FLOWS = EAPP_FLOWS;
  public CUSTOMER_STATUS = ECUSTOMER_STATUS;
  public CONST = CONST;

  constructor() {}

  ngOnInit(): void {}
}
